import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Component from "./component";

const mapStateToProps = ({
    rtoInfo: {
        rtoList,
        pageType,
        cms,
        state
    }
}) => ({
    rtoList,
    pageType,
    cms,
    state
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Component);
